import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export enum CreateGiftReceiptRequestErrorCode {
  UNAUTHORIZED = "UNAUTHORIZED",
  INVALID_INPUT = "INVALID_INPUT",
  FAILED_TO_CREATE_REQUEST = "FAILED_TO_CREATE_REQUEST",
}

export const createGiftReceiptRequest = {
  name: "createGiftReceiptRequest" as const,
  input: z.object({
    email: z.string().email(),
    giftInformation: z.string().min(1),
  }),
  output: z.object({ id: zExt.objectId() }),
};
